export default () => ({
  wasteGroupSynonyms: [],
  activeSynonym: null,
  activeWasteType: null,
  wasteStreams: [],
  activeWasteStreamId: null,
  isWasteStream: null,
  showResults: true
})
